// Simulador de publicação da home (books/_home_simulator).
//
// Só cuida da interface: botões de tipo e formato, slider de páginas, validação antes do
// envio e o mockup do livro. O cálculo continua no servidor: o form é remoto (rails-ujs)
// e as respostas de simulations/*.js.erb preenchem o resultado pelas classes home_simulator-*.

// jQuery da página (carregado antes pelo pack home/application). Declarado aqui para o webpack não
// embutir outra cópia dele neste pack (o ProvidePlugin só injeta onde $ não existe).
var $ = window.jQuery;

function setup(root) {
  if (root.getAttribute('data-cda-sim-bound') === '1') return;
  root.setAttribute('data-cda-sim-bound', '1');

  var $root = $(root);
  var $form = $root.find('.cda-sim__form');
  var $pages = $root.find('[data-cda-sim-pages]');
  var $range = $root.find('[data-cda-sim-pages-range]');
  var $pagesNumber = $root.find('[data-cda-sim-pages-number]');
  var $pagesOutput = $root.find('[data-cda-sim-pages-output]');
  var $mock = $root.find('[data-cda-sim-mock]');
  var $chip = $root.find('[data-cda-sim-chip]');

  function isChecked(type) {
    return $root.find('[data-cda-sim-type="' + type + '"] input[type=checkbox]').is(':checked');
  }

  // Tipo de publicação: impresso e/ou eBook
  function syncTypes() {
    var printed = isChecked('printed');
    var ebook = isChecked('ebook');

    $root.find('[data-cda-sim-type]').each(function() {
      var checked = $(this).find('input[type=checkbox]').is(':checked');
      $(this).toggleClass('is-active', checked);
    });
    $root.find('[data-cda-sim-printed-only]').toggle(printed);
    $root.find('[data-cda-sim-ebook-only]').toggle(ebook);
  }

  // Formato: destaca o card, ajusta a proporção do mockup e recarrega as opções do servidor
  function syncFormat(reload) {
    var $checked = $root.find('[data-cda-sim-format] input:checked');
    $root.find('[data-cda-sim-format]').removeClass('is-active');
    if (!$checked.length) return;

    var $label = $checked.closest('[data-cda-sim-format]').addClass('is-active');
    // proporção e altura real do formato (em relação ao A4): o Pocket sai menor que o 16x23
    if ($mock[0]) {
      $mock[0].style.setProperty('--cda-sim-ratio', String($label.data('ratio')));
      $mock[0].style.setProperty('--cda-sim-scale', String($label.data('scale')));
    }
    $chip.text($label.data('name'));
    updateSpecs();

    if (reload) $.get(root.getAttribute('data-book-format-url'), { page_format_id: $checked.val() });
  }

  function formatId() {
    return $root.find('[data-cda-sim-format] input:checked').val();
  }

  // Ficha técnica do painel: o que está escolhido no form, em chips
  function selectedText(selector) {
    var option = $root.find(selector + ' option:selected');
    return option.val() ? option.text() : '';
  }

  function updateSpecs() {
    var printed = isChecked('printed');
    var $format = $root.find('[data-cda-sim-format].is-active');
    var specs = {
      format: printed && $format.length ? $format.data('name') + ' · ' + $format.data('size') : '',
      paper: printed ? selectedText('#simulation_paper_density_id') : '',
      cover: printed ? selectedText('#simulation_cover_type_id') : '',
      color: printed ? selectedText('#simulation_color') : ''
    };
    $root.find('[data-cda-sim-specs] [data-spec]').each(function() {
      var text = specs[this.getAttribute('data-spec')];
      this.textContent = text;
      this.hidden = !text;
    });
    updateSummary(printed, $format);
  }

  // Resumo no rodapé do form: tipos marcados · formato (se impresso) · páginas
  function updateSummary(printed, $format) {
    var types = $root.find('[data-cda-sim-type]').filter(function() {
      return $(this).find('input[type=checkbox]').is(':checked');
    }).map(function() { return $.trim($(this).text()); }).get();
    $root.find('[data-cda-sim-summary="types"]').text(types.join(' + '));
    var $formatSummary = $root.find('[data-cda-sim-summary="format"]');
    $formatSummary.text(printed && $format.length ? $format.data('name') : '');
    $formatSummary.prop('hidden', !(printed && $format.length));
  }

  // lombada de páginas proporcional à quantidade (3px a 14px)
  function paintThickness(value) {
    var px = Math.max(3, Math.min(14, (parseInt(value, 10) || 0) / 40));
    if ($mock[0]) $mock[0].style.setProperty('--cda-sim-thickness', px + 'px');
  }

  function setPages(value) {
    $pagesOutput.text(value || 0);
    paintThickness(value);
    $pages.val(value);
    paintRange();
  }

  // trilha preenchida até o ponto (o Chrome não tem ::range-progress como o Firefox)
  function paintRange() {
    var el = $range[0];
    if (!el) return;
    var pct = (el.value - el.min) / (el.max - el.min) * 100;
    el.style.setProperty('--cda-sim-fill', pct + '%');
  }

  // A opção vazia que vem do servidor aparece como "Selecione". As respostas de
  // set_book_format/set_paper_density trocam as <option>, por isso o observer.
  var placeholder = root.getAttribute('data-select-placeholder');
  function labelBlankOptions(select) {
    var blank = select.querySelector('option[value=""]');
    if (blank && !blank.textContent.trim()) blank.textContent = placeholder;
    // é só o texto de espera: fica desativado e fora da lista do dropdown
    if (blank) blank.disabled = true;
    refreshDropdown(select);
    updateSpecs();
  }

  // Os selects usam o dropdown v2 (v2/scripts/select.js). Quando as opções mudam,
  // ele precisa ser remontado; a remontagem zera as classes do wrapper, por isso o
  // estado de erro é reaplicado.
  function refreshDropdown(select) {
    if (!window.cdaSelect || !$(select).closest('.cda-select').length) return;
    window.cdaSelect.refresh(select);
    $(select).closest('.cda-select')
      .toggleClass('is-invalid', $(select).hasClass('is-invalid'))
      .toggleClass('is-empty', !select.value);
  }

  // o select nativo fica escondido pelo dropdown: o foco vai para o botão dele
  function focusField(field) {
    var trigger = $(field).closest('.cda-select').find('.cda-select__trigger')[0];
    (trigger || field).focus();
  }
  $root.find('.cda-sim__select').each(function() {
    labelBlankOptions(this);
    new MutationObserver(labelBlankOptions.bind(null, this)).observe(this, { childList: true });
  });

  // Pelo menos um tipo fica marcado: o clique que desmarcaria o último é cancelado
  $root.on('click', '[data-cda-sim-type] input[type=checkbox]', function(event) {
    var others = $root.find('[data-cda-sim-type] input[type=checkbox]').not(this);
    if (!this.checked && !others.is(':checked')) {
      event.preventDefault();
      var $label = $(this).closest('[data-cda-sim-type]').removeClass('is-locked');
      void $label[0].offsetWidth; // reinicia a animação
      $label.addClass('is-locked');
    }
  });
  $root.on('change', '[data-cda-sim-type] input[type=checkbox]', function() {
    syncTypes();
    updateSpecs();
    // campo do tipo desmarcado deixa de ser exigido: some o erro que ele tinha
    $root.find('.cda-sim__form .is-invalid').each(function() {
      if (!isRequired(this)) setFieldError(this, '');
    });
  });
  $root.on('change', '.cda-sim__select', function() {
    $(this).closest('.cda-select').toggleClass('is-empty', !this.value);
    updateSpecs();
  });
  $root.on('change', '[data-cda-sim-format] input', function() { syncFormat(true); });

  $root.on('change', '#simulation_paper_density_id', function() {
    $.ajax({
      url: root.getAttribute('data-paper-density-url'),
      data: { paper_density_id: $(this).val(), page_format_id: formatId() },
      dataType: 'script'
    });
  });

  // slider e campo numérico (20 a 700, o limite do A5/A4) definem as páginas; o campo enviado é oculto
  $range.on('input', function() {
    $pagesNumber.val(this.value);
    setPages(this.value);
  });

  // enquanto digita, não passa de 700 e só acompanha valores já válidos; ao sair do campo,
  // ajusta para o mínimo e número par
  $pagesNumber.on('input', function() {
    var value = parseInt(this.value, 10);
    if (value > 700) {
      value = 700;
      this.value = value;
    }
    if (value >= 20 && value <= 700) {
      $range.val(value);
      setPages(value);
    }
  });

  $pagesNumber.on('change', function() {
    var value = parseInt(this.value, 10) || 20;
    value = Math.min(700, Math.max(20, Math.round(value / 2) * 2));
    this.value = value;
    $range.val(value);
    setPages(value);
  });

  // Campos obrigatórios: só os do tipo marcado (impresso e/ou eBook). Não dá para usar
  // :visible porque no celular as etapas fora da atual também ficam escondidas.
  // "Exemplares para você" é opcional e fica de fora.
  function isRequired(field) {
    if (!isChecked('printed') && $(field).closest('[data-cda-sim-printed-only]').length) return false;
    if (!isChecked('ebook') && $(field).closest('[data-cda-sim-ebook-only]').length) return false;
    return true;
  }

  function moneyValue(input) {
    var thousands = input.getAttribute('data-money-thousands') || '.';
    var decimal = input.getAttribute('data-money-decimal') || ',';
    var raw = String(input.value).split(thousands).join('').replace(decimal, '.');
    return parseFloat(raw) || 0;
  }

  function setFieldError(field, message) {
    var $field = $(field).toggleClass('is-invalid', !!message);
    $field.closest('.cda-select').toggleClass('is-invalid', !!message);
    var $holder = $field.closest('.cda-sim__field');
    var $error = $holder.find('.cda-sim__field-error');
    if (!message) { $error.remove(); return; }
    if (!$error.length) $error = $('<p class="cda-sim__field-error" role="alert"></p>').appendTo($holder);
    $error.text(message);
  }

  // scope: uma etapa (Continuar no celular) ou o form inteiro (envio)
  function validateFields(scope) {
    var $scope = $(scope || $form);
    var invalid = [];
    $scope.find('.cda-sim__select').filter(function() { return isRequired(this); }).each(function() {
      var message = this.value ? '' : root.getAttribute('data-msg-required');
      setFieldError(this, message);
      if (message) invalid.push(this);
    });
    $scope.find('.cda-sim__money .money').filter(function() { return isRequired(this); }).each(function() {
      var message = moneyValue(this) > 0 ? '' : root.getAttribute('data-msg-royalty');
      setFieldError(this, message);
      if (message) invalid.push(this);
    });
    return invalid;
  }

  // o erro some assim que o campo é corrigido
  $root.on('change', '.cda-sim__select.is-invalid', function() {
    if (this.value) setFieldError(this, '');
  });
  $root.on('input keyup', '.money.is-invalid', function() {
    if (moneyValue(this) > 0) setFieldError(this, '');
  });

  // Validação antes do rails-ujs enviar (ajax:before pode ser cancelado)
  $form.on('ajax:before', function(event) {
    if (!isChecked('printed') && !isChecked('ebook')) {
      event.preventDefault();
      return false;
    }

    var invalid = validateFields();
    if (invalid.length) {
      // no passo a passo o primeiro erro pode estar numa etapa anterior: volta até ela
      if (isStepped()) goToStage($stages.index($(invalid[0]).closest('[data-cda-sim-stage]')), { focus: false });
      focusField(invalid[0]);
      event.preventDefault();
      return false;
    }

    startLoading();
    // no celular o resultado é a última etapa: o painel entra no lugar do form
    goToStage(resultIndex);
  });

  // Envio em andamento: botão travado por no mínimo 2s (e até a resposta chegar) e o
  // passo 3 em modo "carregando". O create.js.erb começa escondendo o passo 3 e depois
  // mostra o passo certo já preenchido, então o loading sai sem precisar mexer nele.
  var MIN_LOCK_MS = 2000;
  var $submit = $form.find('.cda-sim__submit');
  var $step1 = $root.find('.home_simulator-result_box-step.step1');
  var $step2 = $root.find('.home_simulator-result_box-step.step2');
  var $step3 = $root.find('.home_simulator-result_box-step.step3');
  var lock = { timer: false, request: false };

  function releaseSubmit() {
    if (!lock.timer && !lock.request) $submit.prop('disabled', false).removeAttr('aria-busy');
  }

  function startLoading() {
    lock.timer = true;
    lock.request = true;
    $submit.prop('disabled', true).attr('aria-busy', 'true');
    setTimeout(function() { lock.timer = false; releaseSubmit(); }, MIN_LOCK_MS);

    $step1.hide();
    $step2.hide();
    $step3.addClass('is-loading').show();
  }

  function stopLoading() {
    $step3.removeClass('is-loading');
    lock.request = false;
    releaseSubmit();
  }

  $form.on('ajax:complete', stopLoading);

  // falhou: volta ao estado inicial do painel (e, no celular, à última etapa do form)
  $form.on('ajax:error', function() {
    $step3.hide();
    $step1.show();
    goToStage(resultIndex - 1, { back: true });
  });

  // No tablet o resultado fica abaixo do form: leva a pessoa até ele
  $form.on('ajax:success', function() {
    if (!isStepped() && window.matchMedia('(max-width: 991.98px)').matches) {
      root.querySelector('[data-cda-sim-result]').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // Passo a passo no celular: uma etapa por vez. O form é o mesmo; as etapas fora da
  // atual só ficam escondidas pelo CSS (is-current), então tudo continua sendo enviado.
  // A última etapa (resultIndex) é o painel de resultado, aberto pelo envio do form.
  var stepped = window.matchMedia('(max-width: 575.98px)');
  var $card = $root.find('.cda-sim__card');
  var $stages = $form.find('[data-cda-sim-stage]');
  var $progress = $form.find('[data-cda-sim-progress]');
  var resultIndex = $stages.length;
  var current = 0;

  function isStepped() {
    return stepped.matches;
  }

  function goToStage(index, options) {
    options = options || {};
    index = Math.max(0, Math.min(resultIndex, index));
    var changed = index !== current;
    current = index;

    $stages.each(function(i) {
      $(this).toggleClass('is-current', i === index)
             .toggleClass('is-back', changed && i === index && options.back === true);
    });
    $progress.find('[data-cda-sim-goto]').each(function(i) {
      $(this).toggleClass('is-done', i < index).toggleClass('is-current', i === index)
             .attr('aria-current', i === index ? 'step' : null);
    });
    $progress.find('[data-cda-sim-progress-count]').text(
      $progress.attr('data-progress-text').replace('%{current}', index + 1).replace('%{total}', resultIndex + 1)
    );
    var step = index === resultIndex ? 'result' : (index === resultIndex - 1 ? 'last' : (index === 0 ? 'first' : 'middle'));
    $form.attr('data-cda-sim-step', step);
    $card.attr('data-cda-sim-view', index === resultIndex ? 'result' : 'form');

    if (!changed || !isStepped()) return;
    // a etapa nova começa no topo do form e o leitor de tela anuncia o título dela
    var top = $form[0].getBoundingClientRect().top;
    if (top < 0 && options.scroll !== false) $form[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (options.focus !== false && index < resultIndex) {
      $stages.eq(index).find('.cda-sim__stage-title')[0].focus({ preventScroll: true });
    }
  }

  // avança só se a etapa atual estiver completa; chegar ao resultado é enviar o form
  // (o ajax:before valida tudo e abre a etapa do resultado)
  function advanceTo(index, options) {
    for (var i = current; i < Math.min(index, resultIndex); i++) {
      var invalid = validateFields($stages[i]);
      if (invalid.length) {
        if (i !== current) goToStage(i, { focus: false, scroll: options && options.scroll });
        focusField(invalid[0]);
        return;
      }
    }
    if (index === resultIndex) $submit[0].click();
    else goToStage(index, options);
  }

  $root.on('click', '[data-cda-sim-next]', function() { advanceTo(current + 1); });
  $root.on('click', '[data-cda-sim-back]', function() { goToStage(current - 1, { back: true }); });
  $root.on('click', '[data-cda-sim-goto]', function() {
    var index = parseInt(this.getAttribute('data-cda-sim-goto'), 10);
    if (index < current) goToStage(index, { back: true });
    else advanceTo(index);
  });

  // Arrastar para os lados troca de etapa: para a esquerda avança (com a mesma validação
  // do Continuar; na última etapa, simula), para a direita volta. Enquanto o dedo arrasta,
  // a etapa acompanha com resistência; o gesto só vale se for mais horizontal que vertical.
  // Decidido que é horizontal, a página para de rolar até soltar o dedo (e a troca de etapa
  // não rola a página); um gesto vertical continua sendo rolagem normal. Ficam de fora o slider, a lista aberta do
  // dropdown e o campo que está sendo digitado (arrastar ali é mover o cursor).
  var SWIPE_MIN = 56;
  var swipe = null;

  function swipeTarget() {
    return current === resultIndex ? $root.find('.cda-sim__panel')[0] : $stages[current];
  }

  function releaseSwipe(el) {
    if (!el) return;
    el.style.transition = 'transform 220ms cubic-bezier(0.2, 0.7, 0.2, 1), opacity 220ms';
    el.style.transform = '';
    el.style.opacity = '';
    setTimeout(function() { el.style.transition = ''; }, 240);
  }

  $card[0].addEventListener('touchstart', function(event) {
    swipe = null;
    if (!isStepped() || event.touches.length !== 1) return;
    var $target = $(event.target);
    if ($target.closest('input[type=range], .cda-select__list, .cda-sim__progress').length) return;
    if ($target.closest('input, textarea').is(document.activeElement)) return;
    var touch = event.touches[0];
    swipe = { x: touch.clientX, y: touch.clientY, dx: 0, axis: null, el: swipeTarget() };
  }, { passive: true });

  $card[0].addEventListener('touchmove', function(event) {
    if (!swipe) return;
    var touch = event.touches[0];
    var dx = touch.clientX - swipe.x;
    var dy = touch.clientY - swipe.y;
    if (!swipe.axis) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      swipe.axis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'x' : 'y';
    }
    if (swipe.axis !== 'x') return;
    // arrasto horizontal: a página não rola junto
    if (event.cancelable) event.preventDefault();
    // sem etapa daquele lado: arrasta bem menos, só para mostrar que é o fim
    var blocked = (dx > 0 && current === 0) || (dx < 0 && current === resultIndex);
    swipe.dx = dx;
    if (swipe.el) {
      swipe.el.style.transform = 'translateX(' + (dx * (blocked ? 0.12 : 0.35)) + 'px)';
      swipe.el.style.opacity = blocked ? '' : String(1 - Math.min(Math.abs(dx) / 600, 0.35));
    }
  }, { passive: false });

  function endSwipe() {
    if (!swipe) return;
    var s = swipe;
    swipe = null;
    if (s.axis !== 'x') return;
    releaseSwipe(s.el);
    if (s.dx <= -SWIPE_MIN && current < resultIndex) advanceTo(current + 1, { scroll: false });
    else if (s.dx >= SWIPE_MIN && current > 0) goToStage(current - 1, { back: true, scroll: false });
  }
  $card[0].addEventListener('touchend', endSwipe);
  $card[0].addEventListener('touchcancel', endSwipe);

  goToStage(0);

  // simulação salva sem nenhum tipo: começa com o impresso
  if (!isChecked('printed') && !isChecked('ebook')) {
    $root.find('[data-cda-sim-type="printed"] input[type=checkbox]').prop('checked', true);
  }
  syncTypes();
  paintRange();
  paintThickness($pages.val());
  // papel/acabamento/cor dependem do formato; se vierem vazios, pede as opções ao servidor
  syncFormat($root.find('#simulation_paper_density_id option').length === 0);
}

document.addEventListener('turbolinks:load', function() {
  Array.prototype.forEach.call(document.querySelectorAll('[data-cda-sim]'), setup);
});
